import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface AddDomainFormProps {
  newDomain: string;
  onDomainChange: (value: string) => void;
  onSubmit: () => void;
  isSubmitting: boolean;
}

export function AddDomainForm({
  newDomain,
  onDomainChange,
  onSubmit,
  isSubmitting,
}: AddDomainFormProps) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
      className="space-y-4"
    >
      <p className="text-sm text-muted-foreground">
        Anyone who signs in with a verified address on this exact domain joins this
        company automatically. Only add domains the customer controls, never shared
        email providers such as gmail.com.
      </p>
      <Input
        placeholder="Domain (e.g., example.com)"
        value={newDomain}
        onChange={(e) => onDomainChange(e.target.value)}
      />
      <Button type="submit" disabled={!newDomain || isSubmitting}>
        {isSubmitting ? "Adding..." : "Whitelist Domain"}
      </Button>
    </form>
  );
}